import { redirect } from 'react-router'

import { buildSessionState } from '@/contexts/auth/session/config'
import { queryClient } from '@/queries'
import { companiesQueryOptions } from '@/queries/companies'

export const sessionLoader = async (): Promise<null> => {
  const { isUserAuthenticated, userId } = buildSessionState()

  if (!isUserAuthenticated || !userId) {
    throw redirect('/login')
  }

  await queryClient.query({
    ...companiesQueryOptions(userId),
    staleTime: 'static',
  })

  return null
}
